import { render, staticRenderFns } from "./addPaymentPool.vue?vue&type=template&id=490c8f1d&scoped=true"
import script from "./addPaymentPool.vue?vue&type=script&lang=js"
export * from "./addPaymentPool.vue?vue&type=script&lang=js"
import style0 from "./addPaymentPool.vue?vue&type=style&index=0&id=490c8f1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490c8f1d",
  null
  
)

export default component.exports